import * as React from 'react';

import { useNewPdDesignEnabled } from '@containers/ProductDetailContainer/ProductDetail/hooks/useNewPdDesignEnabled';

import { IVariantsProps } from '../../../../model';

import { ColorPicker } from './ColorPicker';
import { Container, VariantsList } from './styled';

export const VariantsColorPickers: React.FC<IVariantsProps> = ({
  selectedId,
  variants,
}) => {
  const newDesign = useNewPdDesignEnabled();

  return (
    <Container id="pdVariantsColorPicker" newDesign={newDesign}>
      <VariantsList>
        {variants.map((item) => (
          <ColorPicker
            item={item}
            isSelected={item.webId === selectedId}
            key={item.webId}
          />
        ))}
      </VariantsList>
    </Container>
  );
};
